export function parseCurrency(value: string) {
  return Number(value.replace(/,/g, ''));
}

export const getValueByPath = (path: string, obj: any) => {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};

